import React from "react";
import PropTypes from 'prop-types';
import { Separator } from "../Headers/Separator";
import { CardEntryPost } from "./CardEntry";
import { format } from "date-fns";
import '../../styles/blog.css';



export const Blog = (props) =>{
    return(
        <section id="Blog" className="section">
            <Separator name='Blog'></Separator>
            <div className="container">
                <div className="row">
                    {
                        (props.blogs && props.blogs.length > 0)
                        ?
                            props.blogs.map((post,i) => {
                                if(i<=10){
                                    return( 
                                        <CardEntryPost id={post.id} title={post.title} date={ post.publishDate && post.publishDate.seconds ? format(new Date(post.publishDate.seconds*1000), 'dd/MM/yy') : format(new Date(), 'dd/MM/yy') } author={post.author} image={post.url_image} key={i}> </CardEntryPost>
                                    )
                                }
                                return null;

                            })
                        :
                            null
                    }
                </div>
            </div>
        </section>
    )
}

Blog.propTypes = {
    blogs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        author: PropTypes.string,
        url_image: PropTypes.string,
        publishDate: PropTypes.shape({
            seconds: PropTypes.number,
        }),
    })),
};